
import ImageOne from './Images/2026PicOne.heic';
import ImageTwo from './Images/2026PicTwo.heic';
import ImageThree from './Images/2026PicThree.heic';
import ImageFour from './Images/2026PicFour.heic';
import ImageFive from './Images/2026PicFive.heic';
import VidOne from './Images/2026VidOne.MOV';



const Feb12026 = () => {
  return (

    <div className='bodyJ'>
      <h2 style={{ fontFamily: 'Lucida Console', paddingTop: 30, paddingBottom: 30 }}>Our anniversary in photos!</h2>

      <figure>
        <img style={{ border: '2px solid #000' }} width={350} height={500} src={ImageOne}></img>
        <figcaption style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>This is in the apartment. You guessed what I was up to after I took this pic. Darn!</figcaption>
      </figure>

      <figure>
        <img style={{ border: '2px solid #000' }} width={350} height={500} src={ImageTwo}></img>
        <figcaption style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30 }}>Us at the hotel. We were so excited! But we were very much at the wrong room. Drat.</figcaption>
      </figure>

      <video controls autoPlay loop muted style={{ width: '25%' }}>
        {/* Set the src attribute of the source tag to the imported video variable */}
        <source src={VidOne} type="video/quicktime" />
        {/* Fallback text for browsers that don't support the video tag */}
        Your browser does not support the video tag.
      </video>
      <h1 style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>Logan is Edgar Allen Poe.</h1>

      <figure>
        <img style={{ border: '2px solid #000' }} width={350} height={500} src={ImageThree}></img>
        <figcaption style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30 }}>Wineeee Tastinggggg woohoo! This was a blast. Food was SO yummy.</figcaption>
      </figure>

      <figure>
        <img style={{ border: '2px solid #000' }} width={350} height={500} src={ImageFour}></img>
        <figcaption style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30 }}>Whatta view!! Absolutely amazing. We gotta come back in the summer. </figcaption>
      </figure>

      <figure>
        <img style={{ border: '2px solid #000' }} width={350} height={500} src={ImageFive}></img>
        <figcaption style={{ fontFamily: 'Lucida Console', fontSize: 20, paddingTop: 30 }}>Logan taking a (probably/definitely) better pic of the view--but I got all the view I need right here 😎</figcaption>
      </figure>
    </div >


  );




};


export default Feb12026;